import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RolesReducers } from '../../../store/app.reducers';

const getRolesState = createFeatureSelector<RolesReducers.RolesState>(RolesReducers.TAG);

export const getData = createSelector(getRolesState, (state) => state.data);
export const getSearchInfo = createSelector(getRolesState, (state) => state?.searchInfo);
export const getSort = createSelector(getRolesState, (state) => state?.sort);
export const getPage = createSelector(getRolesState, (state) => state?.page);
